import {
  Balance as IconBalance,
  Budget as IconBudget,
  NationwideCod as IconNationwideCod,
} from '@ahamove/icons/order';
import {
  Button,
  Group,
  Image,
  List,
  Stack,
  ThemeIcon,
  Title,
  rem,
} from '@mantine/core';
import { useTranslations } from 'next-intl';
import { assetPrefix } from '@/lib/constants';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

type ModalAddBankAccountProps = {
  onClose: (confirm: boolean) => void;
};

export default function ModalAddBankAccount({
  onClose,
}: ModalAddBankAccountProps) {
  const isMobile = useIsMobile();
  const handleConfirm = (isConfirmed: boolean) => {
    onClose(isConfirmed);
  };
  const tBooking = useTranslations('booking');
  return (
    <Stack>
      <Title c="neutral.6" order={3}>
        {tBooking('location.add_bank.title')}
      </Title>
      <List
        spacing="xs"
        size="md"
        center
        c="neutral.6"
        styles={{
          item: {
            lineHeight: rem(24),
          },
        }}
      >
        <List.Item
          icon={
            <ThemeIcon variant="transparent" size={40} radius="xl">
              <IconNationwideCod style={{ width: rem(40), height: rem(40) }} />

              <Image
                src={`${assetPrefix}/static/images/cod/arrow.webp`}
                fit="contain"
                pos="absolute"
                top="50%"
                right="40%"
                w={rem(46)}
                h={rem(30)}
              />
            </ThemeIcon>
          }
        >
          <div
            dangerouslySetInnerHTML={{
              __html: tBooking.raw('location.add_bank.step_1'),
            }}
          />
        </List.Item>
        <List.Item
          icon={
            <ThemeIcon variant="transparent" size={40} radius="xl">
              <IconBalance style={{ width: rem(40), height: rem(40) }} />
              <Image
                src={`${assetPrefix}/static/images/cod/arrow.webp`}
                fit="contain"
                pos="absolute"
                top="60%"
                left="40%"
                w={rem(46)}
                h={rem(30)}
                style={{
                  transform: 'rotateY(180deg)',
                }}
              />
            </ThemeIcon>
          }
        >
          <div
            dangerouslySetInnerHTML={{
              __html: tBooking.raw('location.add_bank.step_2'),
            }}
          />
        </List.Item>
        <List.Item
          icon={
            <ThemeIcon variant="transparent" size={40} radius="xl">
              <IconBudget style={{ width: rem(40), height: rem(40) }} />
            </ThemeIcon>
          }
        >
          <div
            dangerouslySetInnerHTML={{
              __html: tBooking.raw('location.add_bank.step_3'),
            }}
          />
        </List.Item>
      </List>
      <Group
        pos={isMobile ? 'fixed' : 'unset'}
        right={isMobile ? rem(16) : rem(24)}
        left={isMobile ? rem(16) : rem(24)}
        bottom={isMobile ? rem(16) : rem(24)}
      >
        <Button
          size="md"
          mih={48}
          onClick={() => handleConfirm(false)}
          variant="default"
          w={`calc(50% - ${rem(8)})`}
          fw={700}
        >
          {tBooking('location.add_bank.later')}
        </Button>
        <Button
          size="md"
          mih={48}
          onClick={() => handleConfirm(true)}
          w={`calc(50% - ${rem(8)})`}
          fw={700}
        >
          {tBooking('location.add_bank.add_account')}
        </Button>
      </Group>
    </Stack>
  );
}
